import 'jquery';

export const getImages = (galleryId) => {

    return $.get(`/ajaxGetGalleryImages/${galleryId}`);
};

